<template>
  <div class="fc-notification-type-head" :data-testid="dataTestid">
    <span class="fc-notification-type-head__ic" aria-hidden="true">
      <v-icon small color="white">{{ icon }}</v-icon>
    </span>
    <div>
      <div class="fc-notification-type-head__title">
        <span>{{ title }}</span>
        <NotificationKindBadge :kind="kind" />
      </div>
      <div v-if="subtitle" class="fc-notification-type-head__sub">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script>
import NotificationKindBadge from '../NotificationKindBadge/NotificationKindBadge.vue';

export default {
  name: 'NotificationConfigureHeader',
  components: { NotificationKindBadge },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    kind: { type: String, default: 'schedule' },
    icon: { type: String, default: 'mdi-bell-outline' },
    dataTestid: { type: String, default: 'notification-configure-header' },
  },
};
</script>
